// PROD-only visibility gate for the Treasury module, mirroring the backend guard (TreasuryAccessGuard).
// The AUTHORITATIVE enforcement is the backend (it 403s every treasury op for a blocked user); this only
// hides the nav item and the route so a blocked admin never lands on a screen that would just error.
// In dev/sandbox (REACT_APP_ENV !== 'production') it is a no-op — open to every admin, unchanged.
//
// Kept in sync with the backend by hand: this list must match TREASURY_PROD_ALLOWED_EMAILS in
// constlending-api-next (src/modules/treasury/constants.ts).
const TREASURY_ALLOWED_EMAILS = ['ricardo@constitutionmgmt.com'];

export const isProd = process.env.REACT_APP_ENV === 'production';

// `operatorEmail` is `session.user.email` (may be null/undefined while the session query loads — in prod
// that reads as "not allowed yet", so callers should gate on the session being loaded before redirecting).
export function canSeeTreasury(operatorEmail) {
  if (!isProd) return true;
  const email = (operatorEmail || '').trim().toLowerCase();
  return TREASURY_ALLOWED_EMAILS.map((e) => e.toLowerCase()).includes(email);
}
